export const ADMIN_CAP_PHAT_TRANG_THIET_BI_PREFIX_URL =
  '/admin-cap-phat-trang-thiet-bi'
